import { useActiveMember } from 'hooks/store';
import { useMemo } from 'react';
import IMemberSettings from 'types/MemberSettings';

export default function useMemberSettings() {
  const { memberSettings } = useActiveMember();
  return useMemo(() => (memberSettings ? (JSON.parse(memberSettings) as IMemberSettings) : null), [memberSettings]);
}
